/** The mode of the per diem archive page */
export enum PerDiemArchiveMode {
  SpecificDate = 'specific-date',
  DateRange = 'date-range',
  SmartPerDiem = 'smart-per-diem',
}
